<template>
  <div class="wrapper" id="app">
    <div id="login">
      <div id="description" class="mobilehide">
        <h1>Login</h1>
        <p>Contipark</p>
        <p>Intelligentes Parkhaus</p>
      </div>
      <div id="description" class="hide-for-desktop">
        <div class="mobile-logo"></div>
      </div>
      <div id="form">
        <form @submit.prevent="handleSubmit" class="login-form">
          <label for="email" class="label">Email</label>
          <input
            type="text"
            id="email"
            v-model="userID"
            placeholder="me@example.com"
            autocomplete="off"
            class="input"
          />
          <label for="password" class="label">
            Password &nbsp;
            <span @click="switchVisibility">
              <span v-show="inputType == 'password'">
                <i class="fas color-white fa-eye"></i>
              </span>
              <span v-show="inputType == 'text'">
                <i class="fas color-white fa-eye-slash"></i>
              </span>
            </span>
          </label>
          <input
            :type="inputType"
            id="password"
            v-model="password"
            placeholder="**********"
            autocomplete="off"
            class="input"
          />
          <button type="submit">Log in</button>
          <div class="forgot-password">
            <a
              class="forgot-password"
              :href="`${NIOTA_URL}/#/reset-password`"
              target="_blank"
            >
              Passwort vergessen?
            </a>
            <!--label class="stay">
              <input name="stay" v-model="stay" class="input-stay" type="checkbox" @change="stayLoggedIn" />
              Angemeldet bleiben
            </label-->
          </div>
        </form>
      </div>
      <div class="fixed-bottom">
        <b-alert :show="integrationDialogVisible" variant="danger" dismissible>
          Diese Anwendung ist für ihren Account nicht aktiviert.
        </b-alert>
      </div>
      <el-dialog
        title="Two Factor Authentication"
        width="320px"
        top="37.5vh"
        :visible.sync="twoFactorDialogVisible"
      >
        <el-form :model="form">
          <el-form-item label="Code" label-width="120">
            <el-input
              type="number"
              maxlength="6"
              placeholder="Enter your 6-digit two-factor code"
              v-model="form.code"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="twoFactorDialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="verifyTwoFactorCode()">
            Confirm
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ApiService from "../services/api-service";
import UserService from "../services/user-service";

const ID = 40;

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      userID: "",
      password: "",
      accountId: null,
      accountName1: null,
      NIOTA_URL: process.env.VUE_APP_NIOTA_URL,
      NIOTA_API: process.env.VUE_APP_NIOTA_API,
      integrationDialogVisible: false,
      twoFactorDialogVisible: false,
      form: {
        code: ""
      },
      preData: null,
      inputType: "password",
      stay: false
    };
  },

  mounted() {
    this.$loader.endLoading("Login");
  },

  methods: {
    showTwoFactorDialog() {
      this.twoFactorDialogVisible = true;
    },
    verifyTwoFactorCode() {
      ApiService.verifyTwoFactorCode(this, this.form.code)
        .then(verified => {
          if (!verified) {
            return this.$notify({
              type: "error",
              message: `Invalid code`,
              position: "bottom-left"
            });
          }
          this.twoFactorDialogVisible = false;
          this.processLogin();
        })
        .catch(error => {
          this.$notify({
            type: "error",
            message: `Ein Fehler in der 2 Faktoren Authentifizierung ist aufgetreten: ${error}`,
            position: "bottom-left"
          });
          this.loading = false;
        });
    },
    showLoginFaild() {
      this.integrationDialogVisible = true;
      this.$notify({
        type: "error",
        message: `Benutzer nicht gefunden oder falsches Passwort`,
        position: "bottom-left"
      });
    },
    handleSubmit() {
      ApiService.login({
        username: this.userID.trim(),
        password: this.password.trim()
      })
        .then(res => {
          let account = res;
          this.preData = account;
          this.accountId = account.tenantId;
          if (this.accountId === ID) {
            this.loading = false;
            this.processLogin();
          } else {
            return this.showLoginFaild();
          }
        })
        .catch(error => {
          this.$notify({
            type: "error",
            message: error,
            position: "bottom-left"
          });
        });
    },
    processLogin() {
      let data = this.preData;

      this.$notify({
        type: "success",
        message: `Logged in as ${data.user.firstName} ${data.user.lastName}`,
        position: "bottom-left"
      });
      UserService.setVerified(true);
      UserService.setUser(data.user);
      this.$store.commit("setUser", data.user);
      this.$store.commit("setAccountId", data.tenantId);
      this.$router.push("Main");
    },
    switchVisibility() {
      if (this.inputType === "password") {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    },
    stayLoggedIn() {
      if (this.stay) {
        this.$store.state.stayLogged = true;
        localStorage.setItem("stayLogged", true);
      }
    }
  }
};
</script>
